import { Component, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-image-viewer',
  imports: [CommonModule],
  template: `
    @if (visible()) {
      <div 
        class="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center"
        (click)="close()">
        <div class="relative max-w-7xl max-h-[90vh] p-4" (click)="$event.stopPropagation()">
          <button
            type="button"
            (click)="close()"
            class="absolute top-4 right-4 p-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors z-10">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <img
            [src]="src()"
            [alt]="alt()"
            class="max-w-full max-h-[90vh] object-contain rounded-lg" />
        </div>
      </div>
    }
  `,
  styles: []
})
export class ImageViewerComponent {
  visible = input<boolean>(false);
  src = input<string>('');
  alt = input<string>('');

  closeEvent = output<void>();

  close(): void {
    this.closeEvent.emit();
  }
}

